<div class="centered-message">
  <span class="informative-message">The various tasks are now accessible directly in Google Drive under the "Tasks" section</span>
  <a href="https://drive.google.com/drive/" target="_blank">Google drive</a>
</div>
